import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import _ from 'lodash';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { fetchPermissions, updatePermissions } from '../actions';
import { selectAllPermissions } from '../selectors';
import { selectUserId } from '../../Api/selectors';
import { Checkbox } from '../../../components/Checkbox';
import { GRANT_PERMISSIONS, WORKFLOW_SELECT } from '../../../components/Permission/constants';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  permissions: {},
};
/* eslint-disable react/prefer-stateless-function */
class UserPermissionsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.getAllPermissions();
    this.setState({
      permissions: !this.props.user?.permissions?.length
        ? {}
        : this.props.user?.permissions?.reduce((acc, p) => ({ ...acc, [p?.name]: p?.value ?? 1 }), {}),
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  setPermission = p => {
    let updatePermissions = this.state.permissions;
    if (this.state.permissions[p] && p === GRANT_PERMISSIONS && this.props.myId === this.props.user.id) {
      return;
    }
    updatePermissions[p] = updatePermissions[p] ? 0 : 1;
    this.setState({ permissions: { ...updatePermissions } });
  };

  handleUpdate = () => {
    const permissionsArray = Object.entries(this.state.permissions)?.reduce((acc, item) => {
      return !!item[1] ? [...acc, item[0]] : acc;
    }, []);
    this.props.updatePermissions(this.props.user.id, permissionsArray);
  };

  renderPermission = p => {
    if (p === WORKFLOW_SELECT && env.clientId !== AppClientId.HILTERMANN) {
      return;
    }
    return (
      <HBox vCenter left style={{ gap: 10 }}>
        <Checkbox checked={!!this.state.permissions[p] ? 1 : 0} onChange={() => this.setPermission(p)} />
        <span>{p[0].toUpperCase() + p.slice(1).replaceAll('_', ' ')}</span>
      </HBox>
    );
  };

  handleCheckAll = () => {
    const { allPermissions } = this.props;
    const updatedPermissions = {};
    allPermissions.forEach(p => {
      if (p === WORKFLOW_SELECT && env.clientId !== AppClientId.HILTERMANN) {
        return;
      }
      updatedPermissions[p] = true;
    });
    this.setState({ permissions: updatedPermissions });
  };

  render() {
    const { user } = this.props;
    return (
      <Card className="user-info-card info-card data">
        <Container>
          <h2>{this.lbl('user.details.permissions')}</h2>
          <Button onClick={this.handleCheckAll}>Check All</Button>
          <List>{this.props.allPermissions?.map(p => this.renderPermission(p))}</List>
          <HBox center vCenter>
            <Button onClick={this.handleUpdate}>Update</Button>
          </HBox>
        </Container>
      </Card>
    );
  }
}

UserPermissionsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allPermissions: selectAllPermissions(),
    myId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getAllPermissions: () => {
      dispatch(fetchPermissions());
    },
    updatePermissions: (userId, permissions) => {
      dispatch(updatePermissions(userId, permissions));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserPermissionsCard = compose(withConnect, withRouter)(UserPermissionsCardComp);
